import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { ConfigurationService } from '../../../services/configuration.service';
import { InfoUser, Delegati } from 'src/app/models/content.model';
import { User } from 'src/app/models/user.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { catchError, delay, switchMap, tap } from 'rxjs/operators';
import { of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavMenuComponent {
  showSpotlight: boolean = false;
  menuIsOpen: boolean = false;
  delegantiList: Array<Delegati>;
  infoUser: InfoUser = new InfoUser();
  listFilter = '';
  isLoading = false;
  userActive: User;
  @Output() showPlaylistIframe = new EventEmitter<boolean>();

  constructor(
    public configurations: ConfigurationService,
    private readonly authService: AuthenticationService,
    private readonly cdr: ChangeDetectorRef) {

  }

  ngOnInit() {
    this.isLoading = true;
    of(void 0).pipe(delay(500),
      switchMap(() => this.authService.getInfoUser$()),
      tap((user) =>this.updateUserInfo(user)),
      switchMap(() => this.authService.getDelegati$()),
      tap(deleganti => {
        this.isLoading = false;
        this.updateDelegati(deleganti);
        this.userActive = this.UserActiveApp;
      }),
      catchError(error => {
        this.isLoading = false;
        return throwError(error);
      })
    ).subscribe(data =>{      
      if(this.authService.userHasRole(environment.showMyPlaylistRole)){
        console.log("ok, sono nella subscribe, apro playlist con l'utente di sessione perchè ho il ruolo");
        this.showPlaylistIframe.emit(true);
      } else{
        console.log("non apro la playlist perchè non ho il ruolo");
      }     
    });
  }

  updateUserInfo(user: InfoUser) {
    this.infoUser = user;
    this.cdr.markForCheck();
  }

  updateDelegati(deleganti: Delegati[]) {
    this.delegantiList = deleganti;
    if (this.delegantiList.length > 4)
      this.showSpotlight = true;
    this.cdr.markForCheck();
  }

  logout() {
    this.authService.logout();
    this.authService.getLogoutDelega();
    this.authService.redirectLogoutUser();
  }

  clearFilter() {
    this.listFilter = '';
    this.cdr.markForCheck();
  }

  impersonifica(id: string) {
    this.showPlaylistIframe.emit(false);
    if(this.authService.isDelegationMode) {
      this.logoutDelegation();
      this.cdr.markForCheck();
    }
    this.authService.getDelegation$(id).subscribe(() => {
        this.menuIsOpen = false;
        this.userActive = this.UserActiveApp;
        this.showPlaylistIframe.emit(true);
        this.cdr.markForCheck();
      }
    );
  }

  get user(): User {
    return this.authService.currentUser;
  }

  get UserActiveApp(): User {
    return this.authService.delegationUser;
  }

  logoutDelegation() {
    //esco dalla playlist con la modalità delega
    this.showPlaylistIframe.emit(false);
    this.cdr.markForCheck();
    this.authService.logoutDelegation();
    //console.log("post logoutDelegation")
    this.userActive = null;
    //rientro in modalità playlist con l'utente di sessione
    var _this = this;
    setTimeout(function () {
      if(_this.authService.userHasRole(environment.showMyPlaylistRole)){
        console.log("ok, sono nella subscribe, apro playlist con l'utente di sessione perchè ho il ruolo");
        _this.showPlaylistIframe.emit(true);
      } else{
        console.log("non apro la playlist perchè non ho il ruolo");
      }           
      _this.cdr.markForCheck();
    }, 500)
    
  }
}
